import { createSelector } from 'reselect'

export const selectFeedbackState = state => state.feedbackTools

export const selectFeedbackFilters = createSelector(selectFeedbackState, data => ({
  search: data.search,
  start: data.start,
  end: data.end,
  feedbackType: data.feedbackType,
  version: data.version,
}))

export const selectFeedbackStoreData = createSelector(selectFeedbackState, data => ({
  search: data.search,
  start: data.start,
  end: data.end,
  feedbackType: data.feedbackType,
  version: data.version,
  page: data.page,
  perPage: data.perPage,
  items: data.items,
  total: data.total,
  isLoading: Boolean(data.isLoading),
  error: data.error,
  isExporting: Boolean(data.isExporting),
  exportError: data.exportError,
}))
